import { useState } from "react";
import { useSubmitWhatsappPhoneMutation } from "../api/twoFactorAuthApi";
import { getWhatsappPhoneError } from "./getWhatsappPhoneError";

const E164_PATTERN = /^\+[1-9]\d{7,14}$/;
const INVALID_PHONE_MESSAGE =
  "Enter a valid phone number in international format, starting with +.";

interface UseWhatsappPhoneResult {
  phone: string;
  setPhone: (value: string) => void;
  validationError: string | null;
  submit: () => void;
  isSubmitting: boolean;
  phoneMasked: string | null;
  apiError: string | null;
}

export const useWhatsappPhone = (): UseWhatsappPhoneResult => {
  const [phone, setPhone] = useState("");
  const [touched, setTouched] = useState(false);
  const [submitPhone, { isLoading, data, error }] =
    useSubmitWhatsappPhoneMutation();

  const isValid = E164_PATTERN.test(phone);
  const validationError = touched && !isValid ? INVALID_PHONE_MESSAGE : null;

  const submit = () => {
    setTouched(true);
    if (!isValid) return;
    submitPhone({ phone });
  };

  return {
    phone,
    setPhone,
    validationError,
    submit,
    isSubmitting: isLoading,
    phoneMasked: data?.phone_masked ?? null,
    apiError: getWhatsappPhoneError(error),
  };
};
